/* Tab content data: hero block + install steps for each platform (iOS, Android, Desktop)
   Brand: casinobiat.online
   Install short link: https://heylink.me/casinobiat/
   Step screenshots are SVG illustrations rendered via StepIllustration. */

const SHORT_LINK = "https://www.casinobiat777.com";

export const TAB_CONTENT = {
    ios: {
        title: "casinobiat.online Mobil Uygulaması Artık iOS'da",
        description:
            "casinobiat.online mobil uygulamasını hemen yükleyin ve kesintisiz bahis almaya devam edin.",
        ctaLabel: "Siteye Git",
        ctaHref: SHORT_LINK,
        deviceIllustration: "iphone",
        howTitle: "casinobiat.online iOS Mobil Uygulama Nasıl Yüklenir?",
        steps: [
            {
                n: 1,
                illust: "ios-1",
                caption: "iPhone cihazınızdan Safari Uygulamasını açınız.",
            },
            {
                n: 2,
                illust: "ios-2",
                caption: "casinobiat.online adresini yazın.",
            },
            {
                n: 3,
                illust: "ios-3",
                caption: "Siteye Git'e basın.",
            },
            {
                n: 4,
                illust: "ios-4",
                caption:
                    'Açılan adreste iOS için "Paylaş", Android için "3 Nokta butonuna basın."',
            },
            {
                n: 5,
                illust: "ios-5",
                caption: "Ana Ekrana Ekle Tuşuna basın.",
            },
            {
                n: 6,
                illust: "ios-6",
                caption: 'Gelen ekranda bulunan "Ekle" butonuna basın.',
            },
            {
                n: 7,
                illust: "ios-7",
                caption: "casinobiat.online Artık Mobil Cihazınızda.",
            },
        ],
    },
    android: {
        title: "casinobiat.online Mobil Uygulaması Artık Android'de",
        description:
            "casinobiat.online mobil uygulamasını hemen yükleyin ve kesintisiz bahis almaya devam edin.",
        ctaLabel: "Siteye Git",
        ctaHref: SHORT_LINK,
        deviceIllustration: "android",
        howTitle: "casinobiat.online Android Mobil Uygulama Nasıl Yüklenir?",
        steps: [
            {
                n: 1,
                illust: "and-1",
                caption:
                    'Android cihazınızdan "Google Chrome" uygulamasını açınız.',
            },
            {
                n: 2,
                illust: "and-2",
                caption: "casinobiat.online adresini yazın.",
            },
            {
                n: 3,
                illust: "and-3",
                caption: "Siteye Git'e basın.",
            },
            {
                n: 4,
                illust: "and-4",
                caption: 'Ekrandaki "3 Noktalı" butona basın.',
            },
            {
                n: 5,
                illust: "and-5",
                caption: "Ana Ekrana Ekle tuşuna basın.",
            },
            {
                n: 6,
                illust: "and-6",
                caption: 'Gelen ekranda bulunan "Ekle" butonuna basın.',
            },
            {
                n: 7,
                illust: "and-7",
                caption: '"Ekle" butonuna tekrar basın.',
            },
            {
                n: 8,
                illust: "and-8",
                caption: "casinobiat.online Artık Android Cihazınızda.",
            },
        ],
    },
    desktop: {
        title: "casinobiat.online Kesintisiz Erişim Linki Artık Masaüstünde",
        description:
            "casinobiat.online kesintisiz erişim linki ile Masaüstü cihazınızda vakit kaybetmeden hızlı bahis almak artık çok kolay.",
        ctaLabel: "Siteye Git",
        ctaHref: SHORT_LINK,
        deviceIllustration: "desktop",
        howTitle:
            "casinobiat.online Kesintisiz Erişim Linki Masaüstüne Nasıl Yüklenir?",
        steps: [
            {
                n: 1,
                illust: "desk-1",
                caption:
                    "Masaüstü cihazınızdan herhangi bir internet tarayıcısını açıp, kırmızı ok ile gösterilen arama bölümüne adres yazınız.",
            },
            {
                n: 2,
                illust: "desk-2",
                caption:
                    'Görselde kırmızı kutu içerisinde gösterilen ikonu tarayıcınızın favorilerim bölümüne sürükleyip, bırakınız. Favorilerim bölümünü **Ctrl + Shift + B tuşlarına aynı anda basarak açabilirsiniz.** Ardından erişim linkiniz hazır olacaktır. Tıklayarak giriş yapabilirsiniz.',
            },
        ],
    },
};

export { SHORT_LINK };
